import React from 'react';

/**
 * Basket page navigation icon
 */
function BasketNavIcon() {
  return (
    <svg
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 604 629.5"
      className="c-icon-nav-size-24"
    >
      <g>
        <g>
          <path
            className="c-icon-nav-path"
            d="M604,629.4H0V166.8h604V629.4z M56.7,572.7h490.7V223.5H56.7V572.7z"
          />
        </g>
        <g>
          <path
            className="c-icon-nav-path"
            d="M510.4,198.4h-56.7c0-78.1-63.5-141.7-141.7-141.7s-141.7,63.5-141.7,141.7h-56.7 c0-109.3,89-198.3,198.3-198.3S510.4,89.1,510.4,198.4z"
          />
        </g>
      </g>
    </svg>
  );
}

export default BasketNavIcon;



// WEBPACK FOOTER //
// ./src/layout/graphics/NavIcons/BasketNavIcon.js